<div class="new-modal">
  <div class="title__wrapper mb-4">
    <span class="title">
      {{ 'ProjectsDashboard.summary.documents.renameModal.title' | translate }}
    </span>

    <button type="button" class="clear-icon bg-transparent border-0 p-0" (click)="close()">
      <svg-icon src="/assets/img/close-icon.svg" />
    </button>
  </div>

  <div mat-dialog-content>
    <input-label
      [label]="'ProjectsDashboard.summary.documents.renameModal.label' | translate"
      [required]="true"
    />

    <input-v2
      [formControl]="fileName"
      [placeholder]="'ProjectsDashboard.summary.documents.renameModal.placeholder' | translate"
      (keydown.enter)="save()"
    />
  </div>

  <mat-dialog-actions class="mb-0 pb-0">
    <div class="d-flex align-items-center justify-content-end w-100 flex-wrap">
      <app-button
        (onClick)="close()"
        class="bold mr-2"
        [config]="{
          size: ButtonSize.SMALL,
          type: ButtonTypes.NEW_SECONDARY_BLUE,
          text: ('ProjectsDashboard.summary.documents.renameModal.cancel' | translate)
        }"
      />

      <app-button
        (onClick)="save()"
        [config]="{
          size: ButtonSize.SMALL,
          type: ButtonTypes.NEW_PRIMARY_BLUE,
          text: ('ProjectsDashboard.summary.documents.renameModal.save' | translate)
        }"
      />
    </div>
  </mat-dialog-actions>
</div>
